import { BOOLEAN_STRING_VALUES, isBooleanLike } from './valueType';

export type FieldType = 'BOOLEAN' | 'STRING';

export type BooleanStringValue = (typeof BOOLEAN_STRING_VALUES)[number];

export function inferFieldType(sampleValues: Array<{ value: string }>): FieldType {
  if (sampleValues.length === 0) {
    return 'STRING';
  }
  return sampleValues.every(({ value }) => isBooleanLike(value)) ? 'BOOLEAN' : 'STRING';
}

// Pad incomplete boolean sample lists so both true and false are offered.
export function ensureBooleanSampleValues<T extends { value: string }>(
  sampleValues: T[],
  createMissing: (value: BooleanStringValue) => T,
): T[] {
  if (sampleValues.length === 0) {
    return sampleValues;
  }
  if (!sampleValues.every(({ value }) => isBooleanLike(value))) {
    return sampleValues;
  }
  const byLower = new Map(sampleValues.map((sample) => [sample.value.toLowerCase(), sample]));
  const result: T[] = [];
  for (const bool of BOOLEAN_STRING_VALUES) {
    const existing = byLower.get(bool);
    result.push(existing ?? createMissing(bool));
  }
  return result;
}
